import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ReactGA from 'react-ga';

const rootEl = document.getElementById('root');

const enabledGA = process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED;
if (enabledGA === 'true') {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
}


ReactDOM.render(<App />, rootEl);

if (module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default;
        ReactDOM.render(<NextApp />, rootEl);
    });
}
